import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { QuestionSettingsComponent } from './question-settings.component'
import { QuestionTypeModule } from '../../../shared';

@NgModule({
  imports:[
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    QuestionTypeModule,
  ],
  declarations:[QuestionSettingsComponent],
  exports:[QuestionSettingsComponent]
})
export class QuestionSettingsModule { }



